module.exports = __webpack_public_path__ + "static/media/lr.a72f71e5.webp";